import { defineMessages } from 'react-intl';

export const BuildingFloor = defineMessages({
  floor: {
    id: 'app.common.buildingFloor.floor',
    defaultMessage: 'Přízemí',
  },
  groundFloor: {
    id: 'app.common.buildingFloor.groundFloor',
    defaultMessage: '{level}.NP',
  },
  undergroundFloor: {
    id: 'app.common.buildingFloor.undergroundFloor',
    defaultMessage: '{level}.PP',
  },
});
